module.exports = __webpack_public_path__ + "static/media/Brightly_ios_5_preview.2d570516.jpg";